import React, {useContext, useState} from 'react';
import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import {toast} from 'react-toastify';
import {
    // getSettingsInfo,
    // editProductSettings,
    getProductGroupSettingsInfo,
    editProductGroupSettings
} from '../../api/api';
import handleUnauthorized401MutateError from "../../utils/handleUnauthorized401MutateError";
import AuthContext from "../../context/AuthContext";
import {Input, Label, Button} from "reactstrap";
import Loader from "../../components/Loader";

function ProductGroupSettingsTab({currentTab, setCurrentTab}) {
    const {refreshToken} = useContext(AuthContext);
    const queryClient = useQueryClient();
    const [settings, setSettings] = useState('');
    const [settingId, setSettingId] = useState(null);

    const { refetch } = useQuery({
        queryKey: ['product-group-settings'],
        queryFn: () => getProductGroupSettingsInfo(),
        keepPreviousData : true,
        retry: false,
        onSuccess: (data) => {
            setSettingId(data.results[0].id);
            setSettings(data.results[0]);
        },
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, refetch);
            if (err.response.status !== 401) {
                toast.error(`An error occurred! ${err?.response?.data?.detail}`);
            }
        }
    });

    const mutation = useMutation(editProductGroupSettings, {
        onSuccess: () => {
            toast.success('Settings updated successfully!');
            queryClient.invalidateQueries(['product-group-settings']);
        },
        onError: (err) => {
            toast.error(`An error occurred! ${err?.response?.data?.detail}`);
        },
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSettings((prevSettings) => ({
            ...prevSettings,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        mutation.mutate({ formData: settings, settingId });
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="settings-card ml-3">
                    <div className="card-box">
                        <div className="form-group">
                            <Label>Default Product Group HSN/SAC Code</Label>
                            <Input
                                type="text"
                                name="default_product_group_hsn_sac"
                                className="form-control"
                                value={settings.default_product_group_hsn_sac}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Label>Default Product Group Unit of Measure</Label>
                            <Input
                                type="text"
                                name="default_product_group_unit_of_measure"
                                className="form-control"
                                value={settings.default_product_group_unit_of_measure}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Label>Default Product Group Tax Type</Label>
                            <Input
                                type="select"
                                name="default_product_group_tax_type"
                                className="form-control"
                                value={settings.default_product_group_tax_type}
                                onChange={handleChange}
                            >
                                <option value="TAX-EXCLUSIVE">TAX-EXCLUSIVE</option>
                                <option value="TAX-INCLUSIVE">TAX-INCLUSIVE</option>
                            </Input>
                        </div>
                        <div className="form-group">
                            <Label>Default Product Group Tax Percentage</Label>
                            <Input
                                type="text"
                                step="0.01"
                                name="default_product_group_tax_percentage"
                                className="form-control"
                                value={settings.default_product_group_tax_percentage}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Label>Default Product Group Status</Label>
                            <Input
                                type="select"
                                name="default_product_group_status"
                                className="form-control"
                                value={settings.default_product_group_status}
                                onChange={handleChange}
                            >
                                <option value="ACTIVE">ACTIVE</option>
                                <option value="INACTIVE">INACTIVE</option>
                            </Input>
                        </div>
                        <Button type="submit" className="btn bx-btn-primary waves-effect waves-light" disabled={mutation.isLoading}>{mutation.isLoading? <><Loader size={'small'}/>Saving...</>: `Save`}</Button>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default ProductGroupSettingsTab;
